import React from 'react';
import { FaTrophy, FaCheck, FaTimes } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';

const TestResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { testResults, currentTest } = location.state || {};

  if (!testResults || !currentTest) {
    return navigate('/dashboard/user');
  }

  return (
    <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 mb-[120px]">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">Test Results</h2>
          <p className="text-gray-600 mt-2">
            {testResults.type} - {testResults.subject}
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <FaTrophy className="text-4xl text-yellow-500" />
          <div className="text-center">
            <p className="text-sm text-gray-600">Your Score</p>
            <p className="text-3xl font-bold text-indigo-600">{testResults.score}%</p>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {currentTest.questions.map((question, index) => {
          const isCorrect = currentTest.answers[index] === question.correct;
          const selectedAnswer = currentTest.answers[index];

          return (
            <div 
              key={index} 
              className={`p-6 rounded-xl border-2 ${
                isCorrect ? 'border-green-100 bg-green-50' : 'border-red-100 bg-red-50'
              }`}
            >
              <div className="flex items-start space-x-3">
                <div className={`mt-1 p-1 rounded-full ${
                  isCorrect ? 'bg-green-500' : 'bg-red-500'
                }`}>
                  {isCorrect ? (
                    <FaCheck className="w-4 h-4 text-white" />
                  ) : (
                    <FaTimes className="w-4 h-4 text-white" />
                  )}
                </div>
                <div className="flex-1">
                  <p className="text-lg font-medium text-gray-900 mb-4">
                    {index + 1}. {question.text}
                  </p>
                  
                  <div className="space-y-2">
                    {question.options.map((option, optIndex) => (
                      <div
                        key={optIndex}
                        className={`p-3 rounded-lg ${
                          optIndex === question.correct
                            ? 'bg-green-100 border border-green-200'
                            : optIndex === selectedAnswer && !isCorrect
                            ? 'bg-red-100 border border-red-200'
                            : 'bg-white border border-gray-200'
                        }`}
                      >
                        <div className="flex items-center">
                          <div className={`w-4 h-4 rounded-full mr-3 ${
                            optIndex === question.correct
                              ? 'bg-green-500'
                              : optIndex === selectedAnswer && !isCorrect
                              ? 'bg-red-500'
                              : 'bg-gray-200'
                          }`} />
                          <span className={`${
                            optIndex === question.correct
                              ? 'text-green-700 font-medium'
                              : optIndex === selectedAnswer && !isCorrect
                              ? 'text-red-700 font-medium'
                              : 'text-gray-700'
                          }`}>
                            {option}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>

                  {!isCorrect && (
                    <div className="mt-4 p-4 bg-white rounded-lg border border-gray-200">
                      <p className="text-sm font-medium text-gray-900">Explanation:</p>
                      <p className="text-sm text-gray-700 mt-1">
                        The correct answer is "{question.options[question.correct]}". 
                        {question.explanation || "This is the most appropriate option based on the context."}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 flex justify-end space-x-4">
        <button
          onClick={() => navigate('/dashboard/user')}
          className="bg-gray-500 text-white py-3 px-6 rounded-xl
                    font-semibold text-lg shadow-lg hover:bg-gray-600 
                    transform hover:scale-[1.02] transition-all duration-200"
        >
          Close Results
        </button>
      </div>
    </div>
  );
};

export default TestResults;